import React from 'react';
import { CustomerReviews } from '@/components/CustomerReviews';

const TOP_REVIEWS = [
  {
    id: 1,
    rating: 5,
    description:
      'I have always been very sceptical regarding money claims… My experience with Fair has been hassle free… overall a worry free process.',
    author: 'Dave Dunstall',
    isVerified: true,
  },
  {
    id: 2,
    rating: 5,
    description:
      'Started just to see if I qualified… they got back to me with 6 potential claims. Emailed every step of the way.',
    author: 'Michael',
    isVerified: true,
  },
  {
    id: 3,
    rating: 5,
    description:
      'Updates at every stage… absolutely pain free. Unlike others that promise so much and… fail to update you regarding your claim.',
    author: 'Diana Lane',
    isVerified: true,
  },
  {
    id: 4,
    rating: 5,
    description:
      'The process makes it extremely easy for people like me who have no records of Licence numbers / agreements.',
    author: 'GM',
    isVerified: true,
  },
];

export const TrustpilotCarousel: React.FC = () => {
  return <CustomerReviews reviews={TOP_REVIEWS} variant="carousel" minimal showDots={true} />;
};

export default TrustpilotCarousel;
